/**
 * Returns true when all visible HVAC Sales eligibility questions have been answered.
 *
 * This is the single source of truth for HVAC eligibility completeness.
 * Both HvacSales.jsx (for rendering) and App.jsx (for button-enable logic) should
 * call this function so changes to the flow only need to be made in one place.
 *
 * @param {Object} values - Current form values
 * @returns {boolean} true when every visible question is answered and the user may proceed
 */
const isHvacEligibilityComplete = (values = {}) => {
  const isSalesPath = values.salesOrService === 'sales'
  if (!isSalesPath) return false

  if (!values.fuelAssistance) return false

  // Fuel-assistance customers are redirected to HEA — only the first question applies
  if (values.fuelAssistance === 'yes') return true

  if (!values.reasonHere) return false

  const ductWorkRequired = values.reasonHere === 'ac'
  if (ductWorkRequired && !values.existingDuctWork) return false

  const rentOrOwnVisible =
    values.fuelAssistance === 'no' &&
    values.reasonHere &&
    (values.reasonHere !== 'ac' || values.existingDuctWork)
  if (rentOrOwnVisible && !values.rentOrOwn) return false

  const homeAgeRequired = values.rentOrOwn === 'own' && values.fuelAssistance === 'no'
  if (homeAgeRequired && !values.homeAge) return false

  const validHomeAges = ['1-10', '11-20', '20+']
  const familySizeVisible =
    values.fuelAssistance === 'no' &&
    values.homeAge &&
    validHomeAges.includes(String(values.homeAge))
  if (familySizeVisible && (values.familySize == null || values.familySize === '')) return false

  const howHeatedVisible =
    values.fuelAssistance === 'no' &&
    values.familySize != null &&
    values.familySize !== '' &&
    ['1', '1-4'].includes(String(values.familySize))

  const howHeatedEmpty =
    values.howHeated == null ||
    values.howHeated === '' ||
    (typeof values.howHeated === 'string' && values.howHeated.trim() === '')

  if (howHeatedVisible && howHeatedEmpty) return false

  return true
}

export default isHvacEligibilityComplete
